import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import React from 'react';
import styled from '@emotion/styled';
import { breakpoints } from "@argo/principles";
import { keyframes } from '@emotion/react';
var LoadingState = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  border: 0;\n  background: transparent;\n  text-align: center;\n  align-self: center;\n  cursor: not-allowed;\n  margin-right: 8px;\n  @media (min-width: ", "px) {\n    margin-right: 0;\n    padding: 20px 24px;\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.slimLittleGuy ? '20px 8px' : '20px 12px';
}, breakpoints.max);
var shineEffect = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    background-position: right;\n  }\n"])));
var LoaderContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: 24px;\n  width: 53px;\n  width: ", ";\n\n  @media (min-width: ", "px) {\n    width: ", ";\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.slimLittleGuy ? '24px' : '53px';
}, breakpoints.max, function (props) {
  return props !== null && props !== void 0 && props.slimLittleGuy ? '53px' : '81px';
});
var LoadingIcon = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: rgb(23,46,117);\n  width: ", ";\n  height: 24px;\n  background-image: linear-gradient(103deg, transparent 33%, rgba(255, 255, 255, 0.2) 50%, transparent 66%);\n  background-size: 300% 100%;\n  animation: ", " 1.5s infinite;\n\n  @media (min-width: ", "px) {\n    width: ", ";\n  }\n"])), function (props) {
  return props !== null && props !== void 0 && props.slimLittleGuy ? '24px' : '53px';
}, shineEffect, breakpoints.max, function (props) {
  return props !== null && props !== void 0 && props.slimLittleGuy ? '53px' : '81px';
});
var LittleGuyLoader = function LittleGuyLoader(_ref) {
  var _ref$slimLittleGuy = _ref.slimLittleGuy,
    slimLittleGuy = _ref$slimLittleGuy === void 0 ? false : _ref$slimLittleGuy;
  return React.createElement(LoadingState, {
    disabled: true,
    id: "loadingState",
    slimLittleGuy: slimLittleGuy
  }, React.createElement(LoaderContainer, {
    "aria-hidden": "true",
    id: "loaderContainer",
    slimLittleGuy: slimLittleGuy
  }, React.createElement(LoadingIcon, {
    id: "loadingIcon",
    slimLittleGuy: slimLittleGuy
  })));
};
export default LittleGuyLoader;